import React from 'react';
import { Link } from 'react-router-dom';

const Security = () => {
  return (
    <div className="min-h-screen bg-[#0A0E23] text-white py-24 px-4">
      <div className="max-w-4xl mx-auto">
        <Link to="/support" className="text-blue-500 hover:underline mb-8 inline-block">
          ← Destek Sayfasına Dön
        </Link>
        
        <h1 className="text-4xl font-bold mb-8">Güvenlik 🔒</h1>
        
        <div className="space-y-12">
          <section>
            <h2 className="text-2xl font-semibold mb-4">İki Faktörlü Doğrulama</h2>
            <p className="text-gray-300 mb-4">
              Hesabınızı nasıl koruyacağınız:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-300">
              <li>2FA kurulumu</li>
              <li>Yedek kodları saklama</li>
              <li>Güvenlik ipuçları</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Veri Güvenliği</h2>
            <p className="text-gray-300 mb-4">
              Verileriniz nasıl korunuyor:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-300">
              <li>SSL şifreleme</li>
              <li>Veri yedekleme</li>
              <li>Gizlilik politikası</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Security;